export default __webpack_public_path__ + "static/media/Destination2.64eec980.png";